import React from 'react'
import { Field } from 'formik';
import FieldWrapper from '../../FieldWrapper';


const AddNewSectionContent = ({values, errors, touched}) => {
    return (
        <div className="section-content-wrapper">
            <FieldWrapper classes="field-text" label={'Titel'} id="optionsTitle" >
                <Field value={values.options.title ? values.options.title : ''} placeholder={'Titel eingeben'} type="text" name="options.title" className="text-regular input-text-box" />
            </FieldWrapper>
            <FieldWrapper classes="field-text" label={'Text'} id="optionsText" >
                <Field value={values.options.text ? values.options.text : ''} placeholder={'Text eingeben'} type="text" name="options.text" className="text-regular input-text-box" />
            </FieldWrapper>
            <FieldWrapper classes="field-text" label={'Link Text'} id="optionsLinkText" >
                <Field value={values.options.linkText ? values.options.linkText : ''} placeholder={'Link Text eingeben'} type="text" name="options.linkText" className="text-regular input-text-box" />
            </FieldWrapper>
        </div>
    )
}

export default AddNewSectionContent